const ArrowRight = () => (
  <>
    <path
      fill="currentColor"
      d="m17.078 12.5-5.439 5.439a.48.48 0 0 0 .006.708q.165.159.354.162a.49.49 0 0 0 .353-.163l6.081-6.08a.8.8 0 0 0 .184-.268.8.8 0 0 0 .053-.298.8.8 0 0 0-.053-.298.8.8 0 0 0-.184-.268l-6.08-6.08a.5.5 0 0 0-.342-.15.48.48 0 0 0-.366.15.5.5 0 0 0-.165.356q0 .192.165.357l5.433 5.433H5.498a.48.48 0 0 0-.356.143.48.48 0 0 0-.143.357q0 .213.143.357a.48.48 0 0 0 .357.143z"
    />
  </>
)
export default ArrowRight
